import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bucketperformance-against-budget-widget',
  templateUrl: './bucketperformance-against-budget-widget.component.html',
  styleUrls: ['./bucketperformance-against-budget-widget.component.scss']
})
export class BucketperformanceAgainstBudgetWidgetComponent implements OnInit {
  chartid: "2";
  dataSource: any;
  width: number = 280;
  height: number = 180;
  type: string = 'msarea';
  dataFormat: string = 'json';

  constructor( ) {
    this.dataSource = {
      "chart": {
        "theme": "fusion",
        "showValues": "0",
        "canvasPadding": "0",
        "drawCrossLine": "1",
        "crossLineColor": "#262626",
        "paletteColors": "#2290F9,#26F1D4",
        "showBorder": "0",
        "crossLineAlpha": "50",
        "numberSuffix": ""
      },
      "categories": [{
        "category": [{
          "label":'Jan',
        }, {
            "label": 'Feb'
        }, {
            "label": 'Mar'
        }, {
            "label": "Apr"
        }, {
          "label":"May"
        }, {
          "label": "Jun"
        }, {
          "label": "Jul"
        }, {
          "label": "Aug"
        }, {
          "label": "Sep"
        }, {
          "label": "Oct"
        }, {
          "label": "Nov"
        }, {
          "label": 'Dec'
        }]
      }],
      "dataset": [{
        "seriesname": "2017",
        "alpha": "80",
        "data": [{
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }]
      }, {
        "seriesname": "2018",
        "alpha": "60",
        "data": [{
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }, {
          "value": "0"
        }]
      }]
    };
   }

  
  ngOnInit() {
  }

}
